export enum VehiclePowerCode {
  /** 立方公分 */
  CubicCm = '0',
  /** 馬力 */
  Hp = '1'
}
